import { Theme } from "@mui/material/styles/createTheme";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    gridContainer: {
        display: "grid",
        gap: theme.spacing(3),
        gridTemplateColumns: "calc(25% - 9px) calc(25% - 9px) calc(25% - 9px) calc(25% - 9px)",
        gridTemplateRows: "calc(50% - 6px) calc(50% - 6px)",
        height: "calc(100vh - 222px)",
        width: "100vw",
        boxSizing: "border-box",
        padding: theme.spacing(6),
    },
}));
